import { render } from "./TheRekionAdminMenuHeader.vue?vue&type=template&id=cff25d88&scoped=true&ts=true"
import script from "./TheRekionAdminMenuHeader.vue?vue&type=script&lang=ts"
export * from "./TheRekionAdminMenuHeader.vue?vue&type=script&lang=ts"

import "./TheRekionAdminMenuHeader.vue?vue&type=style&index=0&id=cff25d88&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cff25d88"]])

export default __exports__